import React from "react";
import { Link } from "react-router-dom";
import BlogCard from "../../../Common/BlogCard";
import { ToTime, ToDateJalali } from "../../../Common/Function";
function CardList({ data }) {
  return <BlogCard blog={data} />;
}

export default CardList;
